import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { AuthProvider } from "./context/AuthContext";
import { Toaster } from "react-hot-toast";
import {
  loadSubscriptionPlansConfig,
  subscribeSubscriptionPlansConfig,
} from "./config/subscriptionPlansConfig";

const root = ReactDOM.createRoot(document.getElementById("root"));

// Load subscription plan config from Firestore before first render so gated
// UI reads admin-managed values (falls back to bundled defaults on failure).
loadSubscriptionPlansConfig().finally(() => {
  // Keep plans in sync with admin edits without requiring a reload.
  subscribeSubscriptionPlansConfig();

  root.render(
    <>
      <AuthProvider>
        <App />
      </AuthProvider>
      <Toaster
        position="top-center"
        containerStyle={{ zIndex: 9999 }}
        toastOptions={{ style: { marginTop: "4rem" } }}
      />
    </>
  );
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
